import { format, isValid } from 'date-fns';

import { Paragraph } from '@zillow/constellation-10';

import { singleTextLineStyles } from '../../../styles/text';

import TourCardContainer from '../TourCard/TourCardContainer';
import TourCardContentContainer from '../TourCard/TourCardContentContainer';
import TourCardImage from '../TourCard/TourCardImage';
import TourCardSelectableControls from '../TourCard/TourCardSelectableControls';

import type { FC } from 'react';
import type { GetUserPropertyDetailsVrModelWebDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

type TourCardSelectableProps = {
  vrModel: Pick<GetUserPropertyDetailsVrModelWebDto, 'label' | 'createDateTimeUtc' | 'creatorName' | 'posterUrl'>;
  isSelected?: boolean;
  onView: () => void;
  onSelect: () => void;
};

const TourCardSelectable: FC<TourCardSelectableProps> = ({ vrModel, isSelected = false, onView, onSelect }) => (
  <TourCardContainer isSelected={isSelected} hasBigBottomBorder={isSelected}>
    <TourCardImage imageSrc={vrModel.posterUrl} isSelected={isSelected} onClick={onSelect} />
    <TourCardContentContainer>
      <Paragraph textStyle="body-bold" css={{ ...singleTextLineStyles }}>
        {vrModel.label || ''}
      </Paragraph>
      <Paragraph textStyle="body-sm" css={{ ...singleTextLineStyles }}>
        {/* @ts-ignore */}
        {`Created ${vrModel.createDateTimeUtc && isValid(new Date(vrModel.createDateTimeUtc)) ? format(new Date(vrModel.createDateTimeUtc), 'MM/dd/yyyy') : '-'}`}
      </Paragraph>
      <TourCardSelectableControls isSelected={isSelected} onView={onView} onSelect={onSelect} />
    </TourCardContentContainer>
  </TourCardContainer>
);

export default TourCardSelectable;
